import axios from "../../../src/utils/axiosInstance";
import store from "../../index.js";

import { NEW_NOTIFICATION } from "../notifications/constants.js";

const _ = require("lodash");

export async function getFileContent(path, specificCustomerId) {
  try {
    const result = await axios.get("/loadUptFile", {
      params: {
        fileName: path,
        customerId: specificCustomerId
      }
    });
    if (_.get(result, "status") === 200) {
      return result.data;
    }
    return {};
  } catch (err) {
    if (_.get(err, "response.status") === 401) {
      authFailed();
    }
    return {};
  }
}

export async function getAvailableFiles() {
  try {
    const result = await axios.get("/getUptFiles");
    if (_.get(result, "status") === 200) {
      return result.data;
    } else {
      throw result;
    }
  } catch (err) {
    if (_.get(err, "response.status") === 401) {
      authFailed();
      return [];
    } else {
      console.log("Failed to load available files: ", err);
      return [];
    }
  }
}

export async function isExistingFile(fileName) {
  try {
    const result = await axios.get("/checkFileExistence", {
      params: {
        fileName
      }
    });
    if (_.get(result, "status") === 200) {
      if (result.data === "File already exists.") {
        return true;
      } else {
        return false;
      }
    } else {
      throw result;
    }
  } catch (err) {
    if (_.get(err, "response.status") === 401) {
      authFailed();
    } else {
      console.log("Could not check if file already exists");
    }
  }
}

export async function saveFile(fileName, file, override = false) {
  try {
    const result = await axios.post("/saveUptFile", {
      fileName,
      file,
      override
    });
    if (_.get(result, "status") === 200) {
      return;
    }
    throw result;
  } catch (err) {
    if (_.get(err, "response.status") === 401) {
      authFailed();
    } else {
      throw "";
    }
  }
}

function authFailed() {
  store.dispatch(NEW_NOTIFICATION, {
    message: "Authentification failed.",
    priority: "error"
  });
}
